import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    browse: {
        id: "menu.browse",
    },
    editor: {
        id: "menu.editor",
    },
    slogen: {
        id: "slogen",
    },
    homework: {
        id: "homework",
    },
    classes: {
        id: "dashboard.classes"
    },
    join: {
        id: "classroom",
    },
    dashboardStudent: {
        id: "studentDashboard.title",
    }
});

export default messages;
